import { AppButton } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useNavigate } from '@tanstack/react-router'
import { BookPlus, Search } from 'lucide-react'
import { useCallback } from 'react'
import { AppSavedSearchQueries } from '@/components/AppSavedSearchQueries'
import { inquirySavedSearch } from '@/lib/saved-search'
import { Route } from '../../index'
import { CreateDealDialog } from '../CreateDealDialog'
import { InquirySearchBox } from './components/InquirySearchBox'
import { InquirySearchDialog } from './components/InquirySearchDialog'
import { useSearchAreaDialogs } from './hooks/useSearchAreaDialogs'

export function SearchArea() {
  const { search } = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const handleSearchChange = useCallback(
    (value: string) => {
      navigate({
        search: (prev: { search?: string; selectedId?: number }) => ({ ...prev, search: value }),
      })
    },
    [navigate],
  )

  const { searchDialogOpen, setSearchDialogOpen, createDialogOpen, setCreateDialogOpen } = useSearchAreaDialogs()

  return (
    <div className='p-4'>
      <div className='flex gap-2 items-end'>
        <div className='flex-1'>
          <InquirySearchBox
            label='引合を検索'
            value={search ?? ''}
            onChange={handleSearchChange}
            placeholder='例: プロジェクト名 キーワード (入力後Enterで検索実行)'
          />
        </div>
        <AppSavedSearchQueries config={inquirySavedSearch} onSelect={handleSearchChange} />
        <AppButton onClick={() => setSearchDialogOpen(true)} variant='outline'>
          <Search />
          詳細検索
        </AppButton>
        <AppButton onClick={() => setCreateDialogOpen(true)}>
          <BookPlus />
          引合登録
        </AppButton>
      </div>

      <InquirySearchDialog
        open={searchDialogOpen}
        onOpenChange={setSearchDialogOpen}
        onSearch={handleSearchChange}
        currentSearchText={search}
      />
      <CreateDealDialog open={createDialogOpen} onOpenChange={setCreateDialogOpen} />
    </div>
  )
}
